import { FC } from 'react';
import BordOneToneIcon from '../BordOneToneIcon/BordOneToneIcon';
import {
  IBordUploaderButton,
  BORD_UPLOADER_BUTTON_TYPE,
  ACCEPTED_FILE_EXTENSION,
  ICON_VARIANT
} from './BordUploaderButton.types';
import { bordColorTheme } from 'styles/styles.constants';
import './BordUploaderButton.scss';

/**
 * this component was copied from dash
 * the component is available to be more adaptable
 */
const BordUploaderButton: FC<IBordUploaderButton> = ({
  label,
  isFilled,
  bordUploaderButtonType,
  disabledBordUploaderButton,
  loading,
  errorText,
  title,
  emptyBordUploaderButtonTitle,
  emptyBordUploaderButtonSubtitle,
  defaultFile,
  handleChangeFile,
  handleDeleteFile,
  handleDownloadFile,
  customWidth,
  defaultWidthFull,
  modeReplaceFile = false,
  acceptFileExtension = [ACCEPTED_FILE_EXTENSION.DOC],
  customClassName = '',
  customContainerClassName = '',
  customFileNameClass = '',
  iconsCustomWidth = '16px',
  standardSize = 8,
  customIconChangeFile = ICON_VARIANT.TRASH
}: IBordUploaderButton) => {
  const renderDefaultWidthFull = defaultWidthFull || 'w-full';
  const classnames = `bordUploaderButton ${renderDefaultWidthFull} ${customClassName}`;
  const emptyBordUploaderButtonClass = disabledBordUploaderButton
    ? BORD_UPLOADER_BUTTON_TYPE.DISABLED
    : bordUploaderButtonType || BORD_UPLOADER_BUTTON_TYPE.DEFAULT;
  const errorButton = bordUploaderButtonType === BORD_UPLOADER_BUTTON_TYPE.ERROR;

  const disabledButton =
    emptyBordUploaderButtonClass === BORD_UPLOADER_BUTTON_TYPE.DISABLED || disabledBordUploaderButton;

  const actionToChangeFile = (file: File) => handleChangeFile?.(file);

  const actionDeleteFile = () => !disabledButton && handleDeleteFile?.();

  const actionDownloadFile = () => {
    if (errorButton || disabledButton) return;
    if (defaultFile?.url === undefined || defaultFile?.url === null) return;
    handleDownloadFile?.(defaultFile.url);
  };

  const handleEventFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event?.target?.files?.[0] as File;
    if (file) actionToChangeFile(file);
  };

  if (loading)
    return (
      <div className={classnames} style={{ width: customWidth }}>
        {label && <div className="labelBordUploaderButton animationLoader loaderTextClass" />}
        <div className={`bordFilledUploaderButtonContainer ${customContainerClassName}`}>
          <div className="bordUploaderButtonSkeletonLoader animationLoader" />
        </div>
      </div>
    );

  return (
    <div className={classnames} style={{ width: customWidth }}>
      {label && <div className={`labelBordUploaderButton ${emptyBordUploaderButtonClass}`}>{label}</div>}
      {isFilled && (
        <>
          <div
            className={`bordFilledUploaderButtonContainer stylesSharedBetweenStates ${emptyBordUploaderButtonClass} ${customContainerClassName}`}
          >
            <div
              className="buttonItemsContainer"
              onClick={e => {
                e.stopPropagation();
                actionDownloadFile();
              }}
            >
              {!errorButton && !!handleDownloadFile && (
                <BordOneToneIcon
                  className="downloadIcon"
                  variant={ICON_VARIANT.DOWNLOAD}
                  standardSize={standardSize}
                  stroke={bordColorTheme.navyBlue[900]}
                  customWidth={iconsCustomWidth}
                />
              )}
              <div className={`fileName ${customFileNameClass}`}>
                {defaultFile?.documentName || defaultFile?.url || defaultFile?.name}
              </div>
            </div>
            {!modeReplaceFile && (
              <button className={`floatIconContainer`} onClick={actionDeleteFile}>
                <BordOneToneIcon
                  variant={ICON_VARIANT.TRASH}
                  standardSize={standardSize}
                  customWidth={iconsCustomWidth}
                />
              </button>
            )}
            {modeReplaceFile && (
              <div className="floatIconContainer bordUploaderButtonContainer">
                <BordOneToneIcon
                  variant={customIconChangeFile || ICON_VARIANT.TRASH}
                  standardSize={standardSize}
                  customWidth={iconsCustomWidth}
                />
                <input
                  className={`hideSystemInput ${disabledButton ? 'disabledFileButton' : ''}`}
                  type="file"
                  disabled={disabledButton}
                  onChange={event => handleEventFile(event)}
                  accept={acceptFileExtension.join(',')}
                />
              </div>
            )}
          </div>
          {errorButton && errorText && <div className="textError">{errorText}</div>}
        </>
      )}
      {!isFilled && (
        <div
          className={`bordUploaderButtonContainer stylesSharedBetweenStates ${emptyBordUploaderButtonClass} ${customContainerClassName}`}
        >
          <BordOneToneIcon
            variant={ICON_VARIANT.UPLOAD}
            standardSize={standardSize}
            stroke={bordColorTheme.navyBlue[500]}
            customWidth={iconsCustomWidth}
          />
          <div className="infoDetailsContainer">
            <div className="title">{title || ''}</div>
            {emptyBordUploaderButtonSubtitle && (
              <div className="subtitle">
                {emptyBordUploaderButtonSubtitle || 'Formatos aceptados: [formato] Peso máximo: [peso]'}
              </div>
            )}
          </div>

          <input
            className={`hideSystemInput ${disabledButton ? 'disabledFileButton' : ''}`}
            type="file"
            disabled={disabledButton}
            onChange={event => handleEventFile(event)}
            accept={acceptFileExtension.join(',')}
          />
        </div>
      )}
    </div>
  );
};

export default BordUploaderButton;
